// Nhận diện URL trỏ tới file PDF (label carrier).
// Loại trừ dataURL canvas (data:image/...) vốn luôn là ảnh, nên không bao giờ là PDF.
// Match cả khi URL có query string (?X-Amz...) hoặc fragment (#...) sau đuôi .pdf
const isPdfUrl = (url) => {
    if (typeof url !== 'string' || url.startsWith('data:')) return false
    return /\.pdf(\?|#|$)/i.test(url)
}

export default isPdfUrl
